import types from './types'
import { Axios } from '@/helpers/axios'

const toggleHideAreaNav = ({ commit }) => commit(types.HIDE_AREA)

const getLoginContent = ({ commit }) => {
    return new Promise((resolve, reject) => {
        Axios.get('/page/login')
            .then(({ data }) => {
                if (data.status !== 'success') throw new Error(data.message || "Sorry, we can't load the site at the moment")

                const { name, mobile_name, body, mobile_body } = data.page[0]
                const loginData = { name, mobile_name, body, mobile_body }

                commit(types.SET_LOGIN_CONTENT, loginData)
                resolve(loginData)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
    })
}

const updateLoginContent = ({ commit }, page) => {
    return new Promise((resolve, reject) => {
        Axios.post('/edit-page', { page })
            .then(({ data }) => {
                if (data.status !== 'success') throw new Error(data.message || "Sorry, we can't load the site at the moment")

                const { name, body, mobileName, mobileBody } = page
                const loginData = {
                    name,
                    body,
                    mobile_name: mobileName,
                    mobile_body: mobileBody
                }

                commit(types.SET_LOGIN_CONTENT, loginData)
                resolve(data)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
    })
}

const getPageIndex = ({ state }, { url, pageId }) => {
    return new Promise((resolve) => {
        const paths = url.split('/').filter(Boolean)

        // for children, we'll need to split the paths up...
        const index = state.pages.findIndex(({ id }) => Number(id) === Number(pageId)) // used to assign to the correct item

        // if child, the mutation will use additional toggles to assign the data..
        if (paths.length > 1) {
            //The child path will be the full URL, not just the child slug
            const parentIndex = state.pages.findIndex(({ path }) => path === `/${paths[0]}`)
            const childIndex = state.pages[parentIndex].children.findIndex(({ path }) => path === url)

            resolve({ parentIndex, childIndex })
            return
        }

        resolve({ index })
    })
}

const getPages = ({ commit }) => {
    return new Promise((resolve, reject) => {
        Axios.get('/pages')
            .then(({ data }) => {
                if (data.status === 'success') {
                    const dashboard = { id: 0, name: 'Dashboard', path: '/dashboard' , order: 0, children: null }
                    const areaPage = { id: 0.01, name: 'Core Skills', path: '/areas' , order: 0.05, children: null }
                    const pages = [dashboard, areaPage, ...data.pages]

                    pages.forEach(page => {
                        // somehow login page is getting added to nav - so this is a failproof
                        if (page.path == '/login') page.hide_from_nav = true
                    })

                    commit(types.SET_PAGES, pages)
                    resolve(data.pages)
                }
                else throw new Error("Sorry, we can't load any pages.")
            })
            .catch(err => {
                console.log({ err })
                commit(types.SET_SITE_ERROR, 'Sorry, the site is currently unavailable. Please check back soon')
                reject(err)
            })
    })
}

const getPageData = ({ state, rootState, commit, dispatch }, url) => {
    return new Promise((resolve, reject) => {
        Axios.get(`/page${url}`)
            .then(async ({ data }) => {
                if (data.status === 'success') {
                    // If there's no user, they could be reading legals from the Login / Signup page,
                    // which needs public access
                    if (!rootState.Auth.user) {
                        let pageIndex = -1

                        if (state.pages) pageIndex = await state.pages.findIndex(({ id }) => id === data.page[0].id)

                        if (pageIndex !== -1) commit(types.SET_PAGE_DATA, { page: data.page[0], index: pageIndex })
                        else commit(types.SET_NEW_PAGE, data.page[0])
                    }

                    dispatch('getPageIndex', { url, pageId: data.page[0].id })
                        .then(obj => {
                            obj && obj.childIndex == 0 || obj.childIndex > 0
                                ? commit(types.SET_PAGE_DATA, { page: data.page[0], index: obj.parentIndex,  childIndex: obj.childIndex})
                                : commit(types.SET_PAGE_DATA, { page: data.page[0], index: obj.index })
                        })

                    resolve(data.page[0])
                }
                else throw new Error("Sorry, the page doesn't exist")
            })
            .catch(err => {
                console.log({ err })
                reject(err)
            })
    })
}

const createPage = ({ dispatch }, { isNew, ...pageData}) => {
    return new Promise((resolve, reject) => {
        const endpoint = isNew ? 'add-page' : 'edit-page'
        const type = isNew ? 'put' : 'post'

        Axios[type](`/${endpoint}`, { page: pageData })
            .then(({ data }) => {
                if (data.status && data.status === 'success') {
                     // we need to pass the new ID, so if we add child pages, the mutation
                     // can find the ID of the parent to assign it to.
                     if (data.response && data.response.id) pageData.id = data.response.id

                    dispatch('addNewlyCreatedPage', pageData) // keeping functions pure, we'll find the page to assign in this action
                    resolve(data)
                } else throw new Error(data.message || "Sorry, we couldn't save the page, please try again later.")
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
    })
}

const addNewlyCreatedPage = ({ state, commit }, pageData) => {
    let parentPageIndex

    if (pageData.parentPage) {
        parentPageIndex = state.pages.findIndex(page => page.path === pageData.parentPage)
    }

    commit(types.ADD_PAGE_TO_NAV, { ...pageData, parentInd: parentPageIndex })
}

/*
    Articles
*/
const getArticles = ({ rootState, commit, dispatch }) => {
    if (!rootState.Auth.token) {
        setTimeout(() => {
            dispatch('getArticles')
        }, 50)

        return
    }

    return new Promise((resolve, reject) => {
        Axios.get('/articles')
            .then(({ data }) => {
                if (data.status === 'success') {
                    commit(types.SET_ARTICLES, data.articles)
                    resolve(data.articles)
                }
                else throw new Error("Sorry, we can't load any articles.")
            })
            .catch(err => {
                console.log({ err })
                commit(types.SET_SITE_ERROR, 'Sorry, the site is currently unavailable. Please check back soon')
                reject(err)
            })
    })
}
const createArticle = ({ commit }, { isNew, ...pageData}) => {
    return new Promise((resolve, reject) => {
        const endpoint = isNew ? 'add-article' : 'edit-article'
        const type = isNew ? 'put' : 'post'

        Axios[type](`/${endpoint}`, { article: pageData })
        .then(({ data }) => {
            if (data.status === 'success') {
                if (data.response && data.response.id) pageData.id = data.response.id

                commit(types.ADD_NEW_ARTICLE, pageData) // keeping functions pure, we'll find the page to assign in this action
                resolve(data)
            } else throw new Error(data.message || "Sorry, we couldn't save the article, please try again later.")
        })
        .catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

const getArticleData = ({ state, commit }, url) => {
    return new Promise((resolve, reject) => {
        Axios.get(url)
            .then(({ data }) => {
                if (data.status === 'success') {
                    // We need the article index, so that we can append the correct data
                    const index = state.articles.findIndex(({ id }) => Number(id) === Number(data.article[0].id)) // used to assign to the correct item

                    commit(types.SET_ARTICLE_DATA, { article: data.article[0], index })
                    resolve(data)
                }
                else throw new Error("Sorry, the page doesn't exist")
            })
            .catch(err => {
                console.log({ err })
                reject(err)
            })
    })
}

const removePage = ({ state, commit }, { id, type, params }) => {
    const index = state[`${type}s`].findIndex(obj => obj.id === id)

    if (type === 'article') commit(types.REMOVE_ARTICLE, index)
    else {
        const { page, child } = params
        const pageInd = state.pages.findIndex(({ path }) => path === `/${page}`)

        if (child) {
            const childInd = state.pages[pageInd].children.findIndex(({ path }) => path === `/${page}/${child}`)
            commit(types.REMOVE_PAGE, { pageInd, childInd })

            return
        }

        commit(types.REMOVE_PAGE, { pageInd })
    }
}

export default {
    toggleHideAreaNav,
    getLoginContent,
    updateLoginContent,
    getPageIndex,
    getPages,
    getPageData,
    createPage,
    addNewlyCreatedPage,
    getArticles,
    createArticle,
    getArticleData,
    removePage
}
